export default "__VITE_ASSET__76330e9b__"